import * as React from "react";
const SvgOrangeWatch = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#F97315"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m15.436 14.945-2.871-1.713c-.5-.297-.907-1.01-.907-1.593V7.842M21.26 12c0 5.111-4.148 9.26-9.26 9.26-5.111 0-9.26-4.149-9.26-9.26 0-5.112 4.149-9.26 9.26-9.26 5.112 0 9.26 4.148 9.26 9.26"
    />
  </svg>
);
export default SvgOrangeWatch;
